var map = {
	"./body.svg": 6459,
	"./boobs-old.svg": 4730,
	"./boobs.svg": 673,
	"./combination.svg": 4069,
	"./dermatology.svg": 5081,
	"./head-old.svg": 1312,
	"./head.svg": 6931,
	"./orthopedics.svg": 3929,
	"./pussy.svg": 6639
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4354;